var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonVCard',[_c('h2',{staticClass:"registration-form__header mb-4"},[_vm._v(" "+_vm._s(_vm.$t("player_registration.player_registration"))+" ")]),_c('CommonPlayerProfileFormField',{attrs:{"changeFormField":_vm.handleChangePlayer,"disabled":_vm.disabled,"fieldValue":_vm.playerRegistration,"items":_vm.players,"label":_vm.$t('player_registration.select_player'),"rules":{
      required: {
        value: 0
      }
    },"type":_vm.RegistrationAnswerType.OPTIONS_CHOOSE_ONE,"customClassName":"mb-2","name":"player"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }